import React, { Fragment } from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
}
export function Modal({
  isOpen,
  onClose,
  title,
  children,
  size = 'md'
}: ModalProps) {
  if (!isOpen) return null;
  const sizeClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    full: 'max-w-4xl'
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden bg-black/50 backdrop-blur-sm p-4 md:p-0" data-id="element-103">
      <div className={`relative w-full ${sizeClasses[size]} bg-white rounded-lg shadow-xl transform transition-all animate-in fade-in zoom-in duration-200`} role="dialog" aria-modal="true" data-id="element-104">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200" data-id="element-105">
          <h3 className="text-lg font-semibold text-slate-900" data-id="element-106">{title}</h3>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-500 hover:bg-slate-100 rounded-full p-1 transition-colors" aria-label="Close" data-id="element-107">
            <X size={20} data-id="element-108" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 max-h-[80vh] overflow-y-auto" data-id="element-109">{children}</div>
      </div>
    </div>;
}